import request from '@utils/request'
import { ReturnType } from './types'
const pay = async (data: any) => {
  try {
    const config: ReturnType = {
      url: 'transactions/pay',
      method: 'post',
      data,
      authorization: true,
      config: {
        showErr: true,
        // successMsg: 'Order created successfully!',
        // store: {
        //   action: 'prepend',
        //   key: 'transactions',
        // },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const verify = async (data: any) => {
  try {
    const config: ReturnType = {
      url: 'transactions/verify',
      method: 'post',
      data,
      authorization: true,
      config: {
        showErr: true,
        // successMsg: 'Order created successfully!',
        // store: {
        //   action: 'prepend',
        //   key: 'transactions',
        // },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const lists = async () => {
  try {
    const config: ReturnType = {
      url: 'transactions',
      method: 'get',
      authorization: true,
      config: {
        showErr: true,
        // successMsg: 'Order created successfully!',
        store: {
          action: 'prepend',
          key: 'transactions',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}

export default { pay, verify, lists }
